import { bindActionCreators } from "redux";
import { call, put, select, take } from "redux-saga/effects";
import * as SIP from "sip.js";

import * as apiCaller from "../../api/apiCaller";
import store from "..";

export const REGISTER_WEBRTC = "REGISTER_WEBRTC";
export const REGISTER_WEBRTC_SUCCESS = "REGISTER_WEBRTC_SUCCESS";
export const REGISTER_WEBRTC_ERROR = "REGISTER_WEBRTC_ERROR";

export const ANSWER_CALL = "ANSWER_CALL";
export const ANSWER_CALL_SUCCESS = "ANSWER_CALL_SUCCESS";
export const ANSWER_CALL_ERROR = "ANSWER_CALL_ERROR";

export const END_CALL = "END_CALL";
export const END_CALL_SUCCESS = "END_CALL_SUCCESS";
export const END_CALL_ERROR = "END_CALL_ERROR";

export const CALL = "CALL";
export const CALL_SUCCESS = "CALL_SUCCESS";
export const CALL_ERROR = "CALL_ERROR";

export const SESSION_WEBRTC = "SESSION_WEBRTC";
export const SESSION_WEBRTC_SUCCESS = "SESSION_WEBRTC_SUCCESS";
export const SESSION_WEBRTC_ERROR = "SESSION_WEBRTC_ERROR";

export const CLOSE_MODAL_CALL = "CLOSE_MODAL_CALL";

const SESSION_STATUS = {
  IDLE: 9,
  OUTBOUND_STARTING: 1,
  OUTBOUND_RINGING: 2,
  INBOUND_RINGING: 4,
  ANSWERING: 12,
};

const option = {
  media: {
    constraints: {
      audio: true,
      video: false,
    },
  },
  sessionDescriptionHandlerOptions: {
    constraints: {
      audio: true,
      video: false,
    },
  },
};
let checkCall = true;

/**
 * Reducer
 */

const initialState = {
  ua: null,
  session: null,
  answerCall: null,
  endCall: null,
  callSession: null,
  modal: false,
};

export const webrtcReducer = (state = initialState, action) => {
  switch (action.type) {
    case REGISTER_WEBRTC:
      return {
        ...state,
      };

    case REGISTER_WEBRTC_ERROR:
      return {
        ...state,
        error: action.error,
      };

    case REGISTER_WEBRTC_SUCCESS:
      return {
        ...state,
        ua: action.payload,
      };
    //call
    case CALL:
      return {
        ...state,
        modal: false,
      };

    case CALL_ERROR:
      return {
        ...state,
        error: action.error,
        modal: false,
      };

    case CALL_SUCCESS: {
      if (action.payload != null) {
        return {
          ...state,
          callSession: action.payload,
          modal: true,
        };
      } else {
        return {
          ...state,
          callSession: action.payload,
          modal: false,
        };
      }
    }
    //end call
    case END_CALL:
      return {
        ...state,
        modal: true,
      };

    case END_CALL_ERROR:
      return {
        ...state,
        error: action.error,
        modal: true,
      };

    case END_CALL_SUCCESS:
      return {
        ...state,
        endCall: action.payload,
        modal: false,
      };
    //answer
    case ANSWER_CALL:
      return {
        ...state,
      };

    case ANSWER_CALL_ERROR:
      return {
        ...state,
        error: action.error,
      };

    case ANSWER_CALL_SUCCESS:
      return {
        ...state,
        answerCall: action.payload,
      };
    //session
    case SESSION_WEBRTC:
      return {
        ...state,
      };
    case SESSION_WEBRTC_SUCCESS:
      return {
        ...state,
        session: action.payload,
      };
    case SESSION_WEBRTC_ERROR:
      return {
        ...state,
        error: action.error,
      };
    //close modal
    case CLOSE_MODAL_CALL:
      return {
        modal: false,
      };
    default:
      return state;
  }
};

/**
 * Action
 */

export const sessionWebrtc = () => ({
  type: SESSION_WEBRTC,
});

export const callNumber = (phoneNumber) => ({
  type: CALL,
  data: {
    phoneNumber,
  },
});

export const answerCall = () => ({
  type: ANSWER_CALL,
});

export const endCall = () => ({
  type: END_CALL,
});

export const mapActionsToProps = (dispatch) => {
  return bindActionCreators(
    {
      callNumber,
      endCall,
      answerCall,
      sessionWebrtc,
    },
    dispatch
  );
};
/**
 * api
 */

const agentInfoApi = () => {
  return apiCaller.get("call-center/agent/status");
};

/**
 * sagas
 */
let session;
export const configWebrtcFlow = function* () {
  try {
    const { data } = yield call(agentInfoApi);
    if (data.extension.webrtc) {
      const ua = new SIP.UA({
        uri: `sip:${data.extension.username}@${data.extension.webrtc.host}`,
        authorizationUser: `${data.extension.username}`,
        password: `${data.extension.password}`,
        register: true,
        transportOptions: {
          wsServers: [
            `wss://${data.extension.webrtc.host}:${data.extension.webrtc.port}${data.extension.webrtc.path}`,
          ],
        },
        usePreloadedRoute: true,
        media: {
          constraints: {
            audio: true,
            video: false,
          },
        },
        sessionDescriptionHandlerOptions: {
          constraints: {
            audio: true,
            video: false,
          },
        },
      });
      ua.on("connected", () => {
        console.log("connected");
      });
      ua.on("registered", () => {
        console.log("registered");
      });
      ua.on("unregistered", () => {
        console.log("unregistered");
      });
      ua.on("error", function (error) {
        console.log("ERROR", error);
      });
      ua.on("invite", function (s) {
        session = s;
        s.type = "inbound";
        s.on("accepted", function () {
          console.log("ACCEPTED");
        });
        s.on("rejected", function () {
          console.log("REJECTED");
        });
        s.on("cancel", function () {
          console.log("CANCEL");
        });
        s.on("failed", function () {
          console.log("FAILED");
        });
        s.on("bye", function () {
          console.log("BYE");
        });

        s.on("trackAdded", function () {
          console.log("TRACK_ADDED");
          var pc = s.sessionDescriptionHandler.peerConnection;
          var player = document.getElementById("player");
          var remoteStream = new MediaStream();
          pc.getReceivers().forEach(function (receiver) {
            remoteStream.addTrack(receiver.track);
          });
          if (typeof player.srcObject !== "undefined") {
            player.srcObject = remoteStream;
          } else if (typeof player.mozSrcObject !== "undefined") {
            player.mozSrcObject = remoteStream;
          } else if (typeof player.src !== "undefined") {
            player.src = URL.createObjectURL(remoteStream);
          } else {
            console.log("Error attaching stream to element.");
          }
          player.play();
        });
        store.dispatch({ type: SESSION_WEBRTC_SUCCESS, payload: { ...s } });
      });
      ua.on("trackAdded", function () {
        console.log("TRACK_ADDED");
        var pc = ua.sessionDescriptionHandler.peerConnection;
        var player = document.getElementById("player");
        var remoteStream = new MediaStream();

        pc.getReceivers().forEach(function (receiver) {
          remoteStream.addTrack(receiver.track);
        });

        if (typeof player.srcObject !== "undefined") {
          player.srcObject = remoteStream;
        } else if (typeof player.mozSrcObject !== "undefined") {
          player.mozSrcObject = remoteStream;
        } else if (typeof player.src !== "undefined") {
          player.src = URL.createObjectURL(remoteStream);
        } else {
          console.log("Error attaching stream to element.");
        }
        player.play();
      });
      ua.start();
      yield put({ type: REGISTER_WEBRTC_SUCCESS, payload: { ua } });
    }
  } catch (error) {
    yield put({ type: REGISTER_WEBRTC_ERROR, error });
  }
};

// export const sessionFlow = function* () {
//     while (true) {
//         yield take(SESSION_WEBRTC)
//         try {
//             yield put({ type: SESSION_WEBRTC_SUCCESS, payload: {  } })
//         } catch (error) {
//             yield put({ type: SESSION_WEBRTC_ERROR, error })
//         }
//     }
// }

export const answerCallFlow = function* () {
  while (true) {
    yield take(ANSWER_CALL);
    try {
      session.accept(option);
      yield put({ type: ANSWER_CALL_SUCCESS, payload: { session } });
    } catch (error) {
      yield put({ type: ANSWER_CALL_ERROR, error });
    }
  }
};

export const endCallFlow = function* () {
  while (true) {
    yield take(END_CALL);
    const s = yield select((state) => state.webrtc.callSession);
    try {
      session.terminate();
      yield put({ type: END_CALL_SUCCESS, payload: { ...session } });
    } catch (error) {
      yield put({ type: END_CALL_ERROR, error });
    }
  }
};

export const callNumberFlow = function* () {
  while (true) {
    const action = yield take(CALL);
    const uaSip = yield select((state) => state.webrtc.ua.ua);
    const phone = action.data.phoneNumber.toString().replace(/[^0-9]/g, "");
    try {
      const callSession = uaSip.invite(phone, option);
      callSession.type = "outbound";
      callSession.on("accepted", function () {
        console.log("ACCEPTED");
        store.dispatch({ type: CALL_SUCCESS, payload: { ...callSession } });
      });
      callSession.on("rejected", function () {
        console.log("REJECTED");
        store.dispatch({ type: CALL_SUCCESS, payload: { ...callSession } });
      });
      callSession.on("cancel", function () {
        console.log("CANCEL");
        store.dispatch({ type: CLOSE_MODAL_CALL });
        store.dispatch({ type: CALL_SUCCESS, payload: { ...uaSip } });
      });
      callSession.on("failed", function () {
        console.log("FAILED");
        store.dispatch({ type: CLOSE_MODAL_CALL });
        // store.dispatch({ type: CALL_SUCCESS, payload:  {...uaSip} })
      });
      callSession.on("bye", function () {
        console.log("BYE");
        store.dispatch({ type: CLOSE_MODAL_CALL });
        store.dispatch({ type: CALL_SUCCESS, payload: { ...uaSip } });
      });

      callSession.on("trackAdded", function () {
        console.log("TRACK_ADDED");
        var pc = callSession.sessionDescriptionHandler.peerConnection;
        var player = document.getElementById("player");
        var remoteStream = new MediaStream();

        pc.getReceivers().forEach(function (receiver) {
          remoteStream.addTrack(receiver.track);
        });

        if (typeof player.srcObject !== "undefined") {
          player.srcObject = remoteStream;
        } else if (typeof player.mozSrcObject !== "undefined") {
          player.mozSrcObject = remoteStream;
        } else if (typeof player.src !== "undefined") {
          player.src = URL.createObjectURL(remoteStream);
        } else {
          console.log("Error attaching stream to element.");
        }
        player.play();
      });

      yield put({ type: CALL_SUCCESS, payload: { ...callSession } });
    } catch (error) {
      yield put({ type: CALL_ERROR, error });
    }
  }
};
